export const extractCookies = (): URLSearchParams => {
  if (typeof document === 'undefined' || !document.cookie) {
    return new URLSearchParams();
  }
  return new URLSearchParams(
    document.cookie
      .split('; ')
      .map((cookie) => cookie.split('='))
      .filter(([key, value]) => key && value)
      .map(([key, value]) => [key, decodeURIComponent(value)]),
  );
};
